<form>
  <mat-form-field style="width: 20rem">
    <mat-label>Calculated Input</mat-label>
    <input type="text" matInput placeholder="Calculated Input" [formControl]="keySelect" [matAutocomplete]="autoGroup" (blur)="checkField(autoGroup.isOpen)" />
    <mat-autocomplete #autoGroup="matAutocomplete" [displayWith]="displayFn" (optionSelected)="emitChange($event)">
      @for (group of filteredKeys | async; track group) {
        <mat-optgroup [label]="group.section">
          @for (key of group.selectors; track key) {
            <mat-option [value]="key">
              {{ key.label }}
            </mat-option>
          }
        </mat-optgroup>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
